/**
 * useSubProductDetails
 *
 * Fetches detail objects for all product-reference components in a product's
 * component list. Results are stored in a keyed map { [product_ref_id]: detail }.
 *
 * Replaces the raw useEffect + useState waterfall in ModelPage.
 */

import { useState, useEffect } from 'react';
import { productService } from '../services';

/**
 * @param {Array|null|undefined} components - Product components array from useProductDetail
 * @returns {Object} Map of { [product_ref_id]: detailObject }
 */
const useSubProductDetails = (components) => {
  const [subProductDetails, setSubProductDetails] = useState({});

  useEffect(() => {
    if (!components) return;

    const productComponents = components.filter(
      c => c.component_type === 'product' && c.product_ref_id
    );

    if (productComponents.length === 0) {
      setSubProductDetails({});
      return;
    }

    let cancelled = false;

    const fetchAll = async () => {
      const details = {};
      await Promise.all(
        productComponents.map(async (comp) => {
          try {
            details[comp.product_ref_id] = await productService.getDetail(comp.product_ref_id);
          } catch {
            // Sub-product fetch failed — section will render with no material rows
          }
        })
      );
      if (!cancelled) setSubProductDetails(details);
    };

    fetchAll();
    return () => { cancelled = true; };
  }, [components]);

  return subProductDetails;
};

export default useSubProductDetails;
